import React, { Component } from "react";
import SidebarContent from "./SidebarContent";
import Sidebar from "react-sidebar";
import App from "../App";
import {
  DSTV,
  GOTV,
  PHCN,
  TRANSFER,
  AIRTIME,
  VGCWATER,
  DEMOSCHOOL,
  JUNGLEJUSTICE
} from "./route-data";
import "../styles/App.css";

export const Dstv = getRoute(DSTV, "dstv");
export const Gotv = getRoute(GOTV, "gotv");
export const Phcn = getRoute(PHCN, "phcn");
export const Transfer = getRoute(TRANSFER, "transfer");
export const Airtime = getRoute(AIRTIME, "airtime");
export const VgcWater = getRoute(VGCWATER, "vgcairtime");
export const DemoSchool = getRoute(DEMOSCHOOL, "demoschool");
export const JungleJustice = getRoute(JUNGLEJUSTICE, "junglejustice");

const mql = window.matchMedia(`(min-width: 800px)`);

function getRoute(info, transactionType) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        info: info,
        mql: mql,
        docked: false,
        open: false,
        sidebarOpen: open
      };
    }

    componentWillMount = () => {
      mql.addListener(this._mediaQueryChanged);
      this.setState({ mql: mql, sidebarDocked: mql.matches });
    };

    componentWillUnmount = () => {
      this.state.mql.removeListener(this._mediaQueryChanged);
    };

    _mediaQueryChanged = () => {
      this.setState({ sidebarDocked: this.state.mql.matches });
    };

    _onSetSidebarOpen = open => {
      this.setState({ sidebarOpen: open });
    };

    _handleToggleSidebar = () => {
      console.log("toggle sidebar");
      this.setState((prevState, props) => {
        return {
          sidebarDocked: !prevState.sidebarDocked
        };
      });
    };

    _handleOpenSidebar = () => {
      //console.log('toggle sidebar');
      this.setState((prevState, props) => {
        return {
          sidebarOpen: !prevState.sidebarOpen
        };
      });
    };

    render() {
      const sidebarContent = SidebarContent(this.state.info);

      return (
        <Sidebar
          sidebar={sidebarContent}
          open={this.state.sidebarOpen}
          onSetOpen={this._onSetSidebarOpen}
          docked={this.state.sidebarDocked}
        >
          <App
            isSidebarDocked={this.state.sidebarDocked}
            handleOpenSidebar={this._handleOpenSidebar}
            transactionType={transactionType}
          />
        </Sidebar>
      );
    }
  };
}

getRoute.propType = {
  transactionType: React.PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/modules/routes/Routes.js